var map = {
	"./EVO.png": 1667,
	"./Path 20295.png": 1668,
	"./ab-img.webp": 1669,
	"./ab-title-cn.webp": 1670,
	"./ab-title-en.webp": 1671,
	"./ag-img.png": 1672,
	"./ag-img.webp": 1673,
	"./ag-title-cn.webp": 1674,
	"./ag-title-en.webp": 1675,
	"./chess-img.webp": 1676,
	"./coin-img.webp": 1677,
	"./content-img.webp": 1678,
	"./dg-img.webp": 1679,
	"./dg-title-cn.webp": 1680,
	"./dg-title-en.webp": 1681,
	"./diamond-img.webp": 1682,
	"./dice-coin.webp": 1683,
	"./ea-img.webp": 1684,
	"./ea-title-cn.webp": 1685,
	"./ea-title-en.webp": 1686,
	"./evo-img.webp": 1687,
	"./evo-title-cn.webp": 1688,
	"./evo-title-en.webp": 1689,
	"./golddice-img.webp": 1690,
	"./gp-img.webp": 1691,
	"./gp-title-cn.webp": 1692,
	"./gp-title-en.webp": 1693,
	"./heart-coin-img.webp": 1694,
	"./lc-bg.webp": 1695,
	"./mg-img.webp": 1696,
	"./mg-title-cn.webp": 1697,
	"./mg-title-en.webp": 1698,
	"./pp-img.webp": 1699,
	"./pp-title-cn.webp": 1700,
	"./pp-title-en.webp": 1701,
	"./pt-img.webp": 1702,
	"./pt-title-cn.webp": 1703,
	"./pt-title-en.webp": 1704,
	"./sa-img.webp": 1705,
	"./sa-title-cn.webp": 1706,
	"./sa-title-en.webp": 1707,
	"./sbo-img.webp": 1708,
	"./sbo-title-cn.webp": 1709,
	"./sbo-title-en.webp": 1710,
	"./spade-img.webp": 1711,
	"./title-cn.webp": 1712,
	"./title-en.webp": 1713,
	"./white-spade-img.webp": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1666;